// Profile data live only in tab memory, never Web Storage.
const values = new Map();
let revision = 0;
export const sensitiveStorageKeys = ['user', 'userInfo', 'loginResponse', 'rangeData', 'selectedItems', 'userRole', 'isAuthenticated', 'rcsSessionVersion', 'authToken', 'accessToken', 'token'];
export const purgeLegacyProfile = () => {
  for (const key of sensitiveStorageKeys) {
    for (const storage of [window.localStorage, window.sessionStorage]) storage.removeItem(key);
  }
};
purgeLegacyProfile();
export const clientState = {
  getItem: key => values.get(key) ?? null,
  setItem: (key, value) => values.set(key, String(value)),
  removeItem: key => values.delete(key),
  clear: () => { values.clear(); revision += 1; },
  revision: () => revision,
};
const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('rcs-auth-events') : null;
if (channel) channel.onmessage = event => {
  if (!['login', 'logout'].includes(event.data)) return;
  clientState.clear();
  window.dispatchEvent(new Event('rcs-session-change'));
  window.dispatchEvent(new Event('rcs-auth-sync'));
};
// Only events are shared. Profiles and credentials are never sent.
export const signalSessionChange = action => channel?.postMessage(action);
